import { render, staticRenderFns } from "./archiveTask.vue?vue&type=template&id=26f2455c&scoped=true"
import script from "./archiveTask.vue?vue&type=script&lang=js"
export * from "./archiveTask.vue?vue&type=script&lang=js"
import style0 from "./archiveTask.vue?vue&type=style&index=0&id=26f2455c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f2455c",
  null
  
)

export default component.exports